export default "__VITE_ASSET__Ctt0YfA2__"